<template>
  <div class="reactions">
    <transition name="fade">
      <div v-if="showMenu" style="animation-duration: .16s" class="reaction-menu">
        <p v-for="react in reactionList" :key="react.id" @click="sendReaction(react)">{{ react.id }}</p>
      </div>
    </transition>
    <div class="reaction-outlet">
      <div v-for="react in reactions" :key="react.id" :style="reactStyle(react.id)" class="reaction">
        <p class="reaction-tag">{{ getPlayerById(react.participantId).name }} {{ react.reaction }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { getUnixTime } from 'date-fns'
import { Howl, Howler } from 'howler'

import { reactionList, audioSprite } from '~/common/reactions.js'
import addReaction from '~/queries/addReaction.gql'

export default {
  props: {
    showMenu: { default: false },
    reactions: { default: [] }
  },
  data () {
    return {
      reactionList,
      sound: null,
      howler: null,
      showReactions: [],
      playedReactions: []
    }
  },
  computed: {
    event () {
      return this.$parent.event
    },
    isMuted () {
      return this.event.settings.isMuted === true
    },
    players () {
      return this.event.participants
    },
    activeEvent () {
      return this.$store.state.activeEvent
    }
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    reactions: function (newReactions) {
      const unplayedReactions = newReactions.filter(r => !this.playedReactions.includes(r.id))

      unplayedReactions.forEach((react) => {
        this.log('new unplayed reaction, playing reaction: ', react)
        const reaction = this.reactionList.filter(x => x.id === react.reaction)[0]
        this.playedReactions.push(react.id)

        if (this.$parent.isModerator && !this.isMuted) {
          this.sound.play(reaction.sound)
        }
      })
    }
  },
  mounted () {
    this.sound = new Howl({
      src: ['/audio/soundboard.webm', '/audio/soundboard.mp3'],
      sprite: audioSprite
    })

    Howler.volume(0.6)
  },
  methods: {
    getPlayerById (id) {
      return this.players.find(player => player.id === id) || {}
    },
    async sendReaction (react) {
      const variables = {
        participantId: this.activeEvent.player.id,
        eventId: this.activeEvent.id,
        reaction: react.id,
        slideNumber: this.event.position.currentSlide,
        slideStep: this.event.position.step
      }
      await this.$apollo.mutate({
        mutation: addReaction,
        variables
      })

      this.$parent.toggleMenu('reactions')
      this.updateLastActiveTime()

      this.$nextTick(() => {
        if (!this.isMuted) { this.sound.play(react.sound) }
      })
    },
    reactStyle (id) {
      let offset = '-20vw'
      let rotate = '-5deg'

      if (id % 3 === 0) { offset = '20vw'; rotate = '5deg' }
      if (id % 2 === 0) { offset = '0vw'; rotate = '0deg' }

      return {
        '--offset': offset,
        '--rotate': rotate
      }
    },
    trackPosthog () {
      this.posthogCapture('player:reaction:send', {
        event_id: this.event.id,
        shortcode: this.event.shortcode,
        player_id: this.activeEvent?.player?.id,
        host_id: this.event.primaryUser
      })
    },
    updateLastActiveTime () {
      const time = getUnixTime(Date.now())
      this.$store.commit('setLastActive', time)
    }
  }
}
</script>
<style lang="scss" scoped>
  .reaction-menu {
    position: fixed;
    width: 85vw;
    padding: 2em 2em 2.2em;
    max-height: 70vh;
    min-height: 40vh;
    max-width: 95vw;
    min-width: 60vw;
    right: 1.8rem;
    bottom: 6rem;
    background:linear-gradient(195deg, #f5f5f5 60%, #eee);
    display: grid;
    // grid-template-columns: repeat(auto-fit, 200px);
    grid-template-rows: repeat(5, 2.6em);
    grid-auto-flow: column;
    gap: .5em;
    z-index: 200;
    box-shadow: 1px 2px 8px rgba(0,0,0,.3);
    text-align: center;
    align-items: center;
    border-radius: 10px;
    overflow-x: scroll;

    p {
      background-color: white;
      font-size: 1.2em;
      display: block;
      width: 5.4em;
      //border: 3px solid white;
      box-sizing: border-box;
      border-radius: 50px;
      padding: 6px 0px;
      box-shadow: 1px 2px 5px rgba(0,0,0,.05);
    }
  }

  .reaction-outlet{
    position:fixed;
    top: 0; left: 0;
    height: 100%;
    width: 100%;
    background-color:transparent;
    z-index: 1000;
    pointer-events: none;

    .reaction {
      font-size: 1.25em;
      animation: bubbleUp 3s ease-in;
      position: fixed;
      bottom: -6em;
      left: 0;
      right: 0;
      margin: 0 auto;
      text-align:center;
      display: flex;
      justify-content: center;

      .reaction-tag {
        max-width: 200px;
        width: auto;
        background-color:white;
        color: var(--text);
        padding: 6px 15px;
        border-radius: 2px;
      }
    }

  }

  @keyframes bubbleUp {
  0% {
    transform: rotate(2deg) translateX(var(--offset)) translateY(0);
  }

  70% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: rotate(var(--rotate)) translateX(calc(var(--offset) * .5)) translateY(calc(-100vh - 3em));
  }
}

  @keyframes wiggle {
  0% {
    transform: rotate(-5deg);
  }

  50% {
    transform: rotate(5deg);
  }

  100% {
    transform: rotate(-5deg);
  }
}
</style>
